/**
 * Features
 *
 * Should be connected to GrowthBook using the `registerFeaturesStorage(callbacks)` function.
 *
 * Accepts:
 * - A simple value: `"feature-flag-name": true`
 * - A value with a filter (app + optional module):
 *   `"feature-flag-name": { filter: [{ app: "gmail", module: "watchRows" }], value: true }`
 *
 * Can be overridden by localStorage:
 * `localStorage.setItem("feature-flag-name", true)`
 */

let featuresInstance = null;

const hasFilter = (featureValue) => {
	return (
		featureValue && typeof featureValue === 'object' && Array.isArray(featureValue?.filter) && 'value' in featureValue
	);
};

const passFilter = (featureValue, moduleData) => {
	return featureValue.filter.some(
		(f) => f.app === moduleData?.package?.name && (!f.module || f.module === moduleData?.config?.name),
	);
};

const isEnabled = (enabled, value) => {
	return enabled && (!hasFilter(value) || passFilter(value, featuresInstance._getModule()));
};

class LsStorage {
	static isOn(f) {
		return !!localStorage.getItem(f);
	}

	static getValue(f) {
		return JSON.parse(localStorage.getItem(f) || 'null');
	}
}

export default class Features {
	constructor() {
		this._getModule = () => {};
		this._isOn = () => false;
		this._getValue = () => false;
	}

	static isOn(f) {
		const enabled = LsStorage.isOn(f) || featuresInstance._isOn(f);
		const featureValue = LsStorage.getValue(f) || featuresInstance._getValue(f);

		return isEnabled(enabled, featureValue);
	}

	static getValue(f) {
		const enabled = LsStorage.isOn(f) || featuresInstance._isOn(f);
		const featureValue = LsStorage.getValue(f) || featuresInstance._getValue(f);

		return isEnabled(enabled, featureValue) ? (hasFilter(featureValue) ? featureValue.value : featureValue) : undefined;
	}

	static registerGetModule(callback = () => {}) {
		featuresInstance._getModule = callback;
	}

	static registerFeaturesStorage(
		storageCallbacks = {
			isOn: () => {},
			getValue: () => {},
		},
	) {
		featuresInstance._isOn = storageCallbacks.isOn;
		featuresInstance._getValue = storageCallbacks.getValue;
	}
}

featuresInstance = new Features();
